// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__2iG2C","tabActive":"styles_tabActive___99vd","tabInactive":"styles_tabInactive__2LZEs"};